var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.09 2.716h-.988a.25.25 0 0 0-.25.262l.083 1.724A5.155 5.155 0 0 0 8 2.882a5.177 5.177 0 0 0-5.167 5.171 5.167 5.167 0 0 0 8.629 3.832.25.25 0 0 0 .01-.363l-.709-.709a.25.25 0 0 0-.34-.011 3.666 3.666 0 1 1 .62-4.798l-2.115-.102a.25.25 0 0 0-.262.25v.988a.25.25 0 0 0 .25.25h4.174a.25.25 0 0 0 .25-.25V2.966a.25.25 0 0 0-.25-.25Z",
    fill: "#9999AC"
  })));
};
export default SvgRefresh;